<template>
  <div v-if="taskId">
    <v-layout row wrap align-center class="mb-3">
      <v-flex justify-space-between style="display: flex; padding-bottom: 1rem;">
        <span class="headline">{{taskTitle}}</span>
        <span class="headline" :style="{'color': taskStateColor}">{{taskState}}</span>
      </v-flex>
      <v-flex v-if="task" shrink>
        <v-btn color="primary" flat outline @click.stop="showAllPhotosDialog = true">
          <v-icon class="mr-1">collections</v-icon>
          All Photos
        </v-btn>
        <v-btn color="primary" flat outline target="_blank" @click.stop="viewReport()">
          <v-icon class="mr-1">visibility</v-icon>
          View report
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row class="task-notes ml-0 mr-0">
      <slot v-if="taskResult">
        <InspectionExpansionPanel :inspection="taskResult" v-if="isRegularInspection"/>
        <HHSExpansionPanel :inspection="taskResult" v-else/>
      </slot>
    </v-layout>
    <v-layout row class="task-notes ml-0 mr-0">
      <v-expansion-panel class="elevation-0" focusable>
        <v-expansion-panel-content>
          <template v-slot:header>
            <v-layout row wrap>
              <v-flex xs6  text-xs-right>
                  <v-chip small>
                    operation history
                  </v-chip>
              </v-flex>
            </v-layout>
          </template>
        <div>
        <v-list>
          <v-list-tile v-for="note in taskNotes" :key="note.id" class="task-note">
            <v-list-tile-content class="flex-direction--row justify-content--left align-items--center">
              <v-chip small>
                {{ note.created_at }}
              </v-chip>
              <v-chip v-if="note.account" small>
                {{ note.account.account }}:
              </v-chip>
              <span>{{ note.message }}</span>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-layout>

    <InspectionAllPhotos v-if="showAllPhotosDialog" :show-all-photos-dialog.sync="showAllPhotosDialog" :images="allPhotos"/>
    <report-review v-if="showReportReviewDialog" @close="showReportReviewDialog = false"/>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import HHSExpansionPanel from './HHSExpansionPanel.vue'
import InspectionExpansionPanel from './InspectionExpansionPanel.vue'
import ReportReview from './ReportReview.vue'
import InspectionArea from './details/InspectionArea.vue'
import InspectionAllPhotos from './details/InspectionAllPhotos.vue'

export default {
  name: 'DetailsTasks',
  components: {
    ReportReview,
    HHSExpansionPanel,
    InspectionExpansionPanel,
    InspectionArea,
    InspectionAllPhotos,
  },

  data() {
    return {
      showDialog: false,
      showReportDialog: false,
      showReportReviewDialog: false,
      showAllPhotosDialog: false,
      isEditing: false,
    }
  },
  computed: {
    ...mapGetters({
      task: 'Tasks/getSelectedTask',
    }),

    reportURL() {
      if (!this.task || !this.task.id) {
        return null;
      }
      return this.task.reportURL
    },
    taskId() {
      if (!this.task || !this.task.id) {
        return null;
      }
      return this.task.id
    },
    taskNotes() {
      if (!this.task || !this.task.id) {
        return []
      }
      return this.task.note
    },
    isRegularInspection() {
      return (this.task && this.task.title === 'inspections')
    },
    taskResult() {
      return this.task
    },
    allPhotos() {
      if (!this.task) {
        return []
      }
      return this.task.allPhotos
    },

    taskState() {
      if (!this.task) {
        return '';
      }
      switch(this.task.status) {
        case -1:
          return 'Deleted'
        case 0:
          return 'Scheduled'
        case 1:
          return 'Confirmed'
        case 2:
          return 'Performing'
        case 7:
          return 'Reporting'
        case 8:
          return 'Performed'
        case 9:
          return 'Reported'
        case 10:
          return 'Archived'
        default:
          return 'Unknown state'
      }
    },

    taskStateColor() {
      if (!this.task) {
        return '';
      }
      switch(this.task.status) {
        case -1:
          return 'red'
        case 0:
          return 'yellow'
        case 1:
          return 'green'
        case 2:
          return 'blue'
        case 7:
          return 'skyblue'
        case 8:
          return 'purple'
        case 9:
          return 'grey'
        case 10:
          return 'grey'
        default:
          return ''
      }
    },

    taskTitle() {
      if (!this.task) {
        return '';
      }
      switch(this.task.title) {
        case 'hhs':
          return 'Healthy House Standard'
        case 'inspections':
          return 'Regular Inspection'
        default:
          return 'Unknown task';
      }
    },

  },
  async mounted() {
    console.log('DetailsTasks mounted');
  },

  async beforeRouteUpdate(to, from, next) {
    console.log('DetailsTasks beforeRouteUpdate', to.params);
    await this.fetchTaskDetails(to.params.id)
    next()
  },
  watch: {
    task: {
      handler(val, old) {
        // Reset Validation if value is null
        console.log({val, old, current: this.task});
      },
      deep: false,
    },
  },
  methods: {
    ...mapActions({
      fetchTaskDetails: 'Tasks/fetchSelected',
      // startManualRevision: 'Tasks/startManualRevision',
      // saveManualRevision: 'Tasks/saveManualRevision',
      // fetchRegularInspection: 'HouseList/Inspections/get',
    }),
    viewReport() {
      this.showReportReviewDialog = true;
    },
  },

}
</script>

<style lang="stylus" scoped>
  .flex-direction--row {
    flex-direction: row;
    padding: 0 0;
  }

  .justify-content--left {
    justify-content: left;
  }

  .align-items--center {
    align-items: center;
  }

  .task-note {
    padding: 0;
  }

</style>
